module.exports = __webpack_public_path__ + "a7acb3a99e169233d291ddbefc85abbd.png";


//////////////////
// WEBPACK FOOTER
// ./work/swipolitique/img/left.png
// module id = 758
// module chunks = 0